import { store } from '../../store/store';
import { popFocus } from '../../store/slices/focus.slice';

function closeMenu() {
  const { focus, magicRemote } = store.getState();
  if (focus.stack.length && magicRemote.enabled) {
    store.dispatch(popFocus());
  }
}

export default closeMenu;
